import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { VehicleFoundComponent } from '../vehicle-found/vehicle-found.component';

@Component({
    selector: 'app-add-vehicle',
    templateUrl: './add-vehicle.component.html',
    styleUrls: ['./add-vehicle.component.scss'],
    standalone: false
})
export class AddVehicleComponent implements OnInit {
  addVehicleForm: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<AddVehicleComponent>,
    private dialog: MatDialog
  ) {
    this.addVehicleForm = new UntypedFormGroup({
      vin: new UntypedFormControl('', [
        Validators.required,
        Validators.maxLength(17),
        Validators.minLength(17),
      ]),
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    if (this.addVehicleForm.valid) {
      this.dialog.open(VehicleFoundComponent, {
        height: '85vh',
        // width: '60vw',
        data: this.addVehicleForm.value,
      });
    }
    this.dialogRef.close();
  }
}
